import {Screen} from 'src/types';
import * as Sentry from '@sentry/react';
import {getLogger} from 'src/utils/logger';

export class UserFacingError extends Error {}

export const handleUnexpectedError = (
  screen: Screen,
  error: Error | unknown,
) => {
  Sentry.captureException(error);
  getLogger().log('crypto_payin_session.error', {error});
};

// TODO(struong): consider setting up an error map. consumers would just specify
// an error key to render the right screen error. the pro of this is that we can
// centralize errors into one place, and then easily make changes to its struct
// over time as needed.
